// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"o7-z"};